// extracted by mini-css-extract-plugin
export default {"fqdn":"FqdnCell-fqdn_bTtFu","textBreak":"FqdnCell-textBreak_pWpYW","fqdnContainer":"FqdnCell-fqdnContainer_yasIV","tld":"FqdnCell-tld_O1CHO"};